import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Login from '../pages/Auth/Login/Login';
import PageNotFound from '../components/WildCard/PageNotFound';
import SignUp from '../pages/Auth/SignUp/SignUp';
import Otp from '../components/Otp/Otp';
import SuccessCard from '../components/SuccessCard/SuccessCard';
import ForgetPassword from '../pages/Auth/Forget-Password/ForgetPassword';
import PasswordReset from '../pages/Auth/Forget-Password/PassswordReset';
import ChooseDemo from '../pages/ChooseDemo/ChooseDemo';

import SupplierManagement from '../pages/SupplierManagement/SupplierManagement';
import SupplierApplication from '../pages/SupplierManagement/SupplierApplication/SupplierApplication';
import ProtectedRoute from '../guards/ProtectedRoute';
import WorkflowConfiguration from '../pages/Configurations/WorkFlowConfiguration/WorkflowList';
import CommandConfig from '../pages/Configurations/WorkFlowConfiguration/CommandConfig/CommandConfig';
import StepConfig from '../pages/Configurations/WorkFlowConfiguration/StepConfig/AddEditStepConfig';
import ProtectedLayout from '../layouts/ProtectedLayout';
import WorkFlowSteps from '../pages/Configurations/WorkFlowConfiguration/StepConfig/StepList';
import ApplicationsOnMyDesk from '../pages/ApplicationDesk/ApplicationDesk';
import UserManagement from '../pages/Configurations/UserManagement/UserManagement';
import Operator from '../pages/Configurations/UserManagement/Operator';
import CreateProcurementForm from '../pages/ProcurementProject/CreateProcurementForm';
import ParameterConfig from '../pages/Configurations/WorkFlowConfiguration/ParameterConfig/ParameterConfig';
import RolePermission from '../pages/Configurations/RoleManagement/RolePermission';
import NavigationMenu from '../pages/Configurations/NavigationMenu/NavigationMenu';
import SupplierRequests from '../pages/SupplierRequests/SupplierRequests';
import AccessibleModules from '../pages/AccessibleModules/ApplicationModules';
import OperatorModule from '../pages/OperatorModule/OperatorModule';
import OperatorDashboard from '../pages/OperatorModule/OperatorDashboard';
import Dashboard from '../pages/Dashboard/Dashboard';
import GoodsServiceCatalogue from '../pages/GoodsServiceCatalogue/GoodsServiceCatalogue';
import ProductDetails from '../pages/GoodsServiceCatalogue/components/ProductDetails';
import CartPage from '../pages/GoodsServiceCatalogue/components/CartPage';
import SearchResults from '../pages/GoodsServiceCatalogue/SearchResults/SearchResults';
import Profile from '../pages/Configurations/Profile/Profile';
import OrderDetailsPage from '../pages/GoodsServiceCatalogue/components/OrdersPage/OrderDetailsPage';
import ProcurementRequests from '../pages/ProcurementProject/ProcurementRequests';
import SupplierRequestsView from '../pages/ProcurementProject/SupplierRequestsView';
import ExpressionOfInterestBid from '../pages/ProcurementProject/ExpressionOfInterestBid';
import ProcurementDashboard from '../pages/ProcurementProject/ProcurementDashboard';
import LookupComponent from '../pages/Configurations/Lookup/Lookup';
import { NotificationPage } from '../pages/Notification';
import ProcurementHomepage from '../pages/ProcurementProject/ProjectProcurementHomepage';
import ExpressionOfInterestPage from '../pages/ProcurementTenderBid/ExpressionOfInterestPage';
import ProcurementProposalPage from '../pages/ProcurementProposal/ProcurementProposalPage';
import Settings from '../pages/Settings/Settings';
import OperatorManagement from '../pages/OperatorManagement/OperatorManagement';
import SignupOptions from '../pages/Auth/SignUp/SignupOptions';
import Index from '../pages/OperatorManagement/Index';
import ConfirmEmail from '../pages/Auth/ConfirmEmail';
import NotificationManagementComponent from '../pages/Configurations/NotificationManagement';
import ContractsHomePage from '../pages/Contracts';
import ContractsDetailsPage from '../pages/ContractsDetails';
import TechnicalInformationPage from '../pages/ProcurementTenderBid/TechnicalInformationPage';
import ProcurementBidTimelinePage from '../pages/ProcurementTenderBid/ProcurementBidTimelinePage';
import CommercialInformationPage from '../pages/ProcurementTenderBid/CommercialInformationPage';
import ExpressionOfInterestProposalPage from '../pages/ViewBids/ExpressionOfInterestPage';
import CommercialInformationProposalPage from '../pages/ViewBids/CommercialInformationPage';
import TechnicalInformationProposalPage from '../pages/ViewBids/TechnicalInformationPage';
import ConfirmEmailComponent from '../pages/Auth/ConfirmEmail';
import ExternalMetrics from '../pages/external/Metrics';
import ComingSoon from '../components/WildCard/ComingSoon';
import RegistrationCertificate from '../pages/SupplierManagement/RegistrationCertificate/RegistrationCertificate';
import EmailTemplate from '../pages/Auth/EmailTemplate/EmailTemplate';

const RouterConfig: React.FC = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Navigate to="/login" />} />
      <Route path="/success-card" element={<SuccessCard title="Success" />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<SignUp />} />
      <Route path="/otp" element={<Otp />} />
      <Route path="reset-password" element={<PasswordReset />} />
      <Route path="/forgot-password" element={<ForgetPassword />} />
      <Route path="/choose-demo" element={<ChooseDemo />} />
      <Route path="/application-module" element={<AccessibleModules />} />
      <Route path="/catalogue/search" element={<SearchResults />} />
      <Route path="/signup-options" element={<SignupOptions />} />
      <Route path="/account/confirmEmail" element={<ConfirmEmailComponent />} />
      <Route path="/external/metrics" element={<ExternalMetrics />} />
      <Route path="/registrationcertificate" element={<RegistrationCertificate />} />
      <Route path="/emailtemplate" element={<EmailTemplate />} />

      {/* Protected Routes with Shared Layout */}
      <Route
        element={
          <ProtectedRoute>
            <ProtectedLayout />
          </ProtectedRoute>
        }
      >
        <Route element={<ProtectedLayout />}></Route>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route
          path="/supplier-registration"
          element={
            <ProtectedRoute
              requiredRoles={['Supplier', 'UnverifiedSupplier', 'Regulator', 'System User']}
            >
              <SupplierManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/supplier-application"
          element={
            <ProtectedRoute
              requiredRoles={[
                'Supplier',
                'UnverifiedSupplier',
                'Regulator',
                'Admin',
                'System User',
              ]}
            >
              <SupplierApplication />
            </ProtectedRoute>
          }
        />
        <Route path="/operator-module" element={<OperatorModule />} />
        <Route
          path="/configuration/workflow"
          element={
            <ProtectedRoute requiredRoles={['Regulator', 'Admin', 'System User']}>
              <WorkflowConfiguration />
            </ProtectedRoute>
          }
        />
        <Route
          path="/configuration/workflow/parameter"
          element={
            <ProtectedRoute requiredRoles={['Regulator', 'Admin', 'System User']}>
              <ParameterConfig />
            </ProtectedRoute>
          }
        />
        <Route
          path="/catalogue"
          element={
            <ProtectedRoute requiredRoles={['Regulator', 'Admin', 'System User', 'Supplier']}>
              <GoodsServiceCatalogue />
            </ProtectedRoute>
          }
        />
        <Route
          path="/configuration/workflow/command"
          element={
            <ProtectedRoute
              requiredRoles={['Regulator', 'Supplier', 'Admin', 'Operator', 'System User']}
            >
              <CommandConfig />
            </ProtectedRoute>
          }
        />
        <Route
          path="/configuration/workflow/steps"
          element={
            <ProtectedRoute requiredRoles={['Regulator', 'Admin', 'System User']}>
              <WorkFlowSteps />
            </ProtectedRoute>
          }
        />
        <Route
          path="/configuration/workflow/step"
          element={
            <ProtectedRoute requiredRoles={['Regulator', 'Admin', 'System User']}>
              <StepConfig />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings/supplier-profile"
          element={
            <ProtectedRoute requiredRoles={['Supplier']}>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/catalogue/order/:orderId"
          element={
            <ProtectedRoute
              requiredRoles={['Supplier', 'Operator', 'Admin', 'Regulator', 'System User']}
            >
              <OrderDetailsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/operator-management"
          element={
            <ProtectedRoute requiredRoles={['Admin', 'Regulator', 'System User']}>
              <OperatorManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/operator-management/:id"
          element={
            <ProtectedRoute requiredRoles={['Admin', 'Regulator', 'System User']}>
              <OperatorManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users/operators"
          element={
            <ProtectedRoute requiredRoles={['Admin', 'Regulator', 'System User']}>
              <Index />
            </ProtectedRoute>
          }
        />
        <Route
          path="/requests/supplier-requests"
          element={
            <ProtectedRoute requiredRoles={['Admin', 'Regulator', 'System User']}>
              <SupplierRequests />
            </ProtectedRoute>
          }
        />
        <Route
          path="/operator-dashboard"
          element={
            <ProtectedRoute requiredRoles={['Operator']}>
              <OperatorDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/application-desk"
          element={
            <ProtectedRoute requiredRoles={['Admin', 'Regulator', 'System User']}>
              <ApplicationsOnMyDesk />
            </ProtectedRoute>
          }
        />
        <Route
          path="/configuration/roles"
          element={
            <ProtectedRoute requiredRoles={['Admin', 'Regulator', 'System User']}>
              <RolePermission />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute
              requiredRoles={['Admin', 'Regulator', 'System User', 'Supplier', 'Operator']}
            >
              <Settings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/configuration/menu"
          element={
            <ProtectedRoute requiredRoles={['Admin', 'Regulator', 'System User']}>
              <NavigationMenu />
            </ProtectedRoute>
          }
        />
        <Route
          path="/configuration/lookup"
          element={
            <ProtectedRoute requiredRoles={['Admin', 'Regulator', 'System User']}>
              <LookupComponent />
            </ProtectedRoute>
          }
        />
        <Route
          path="/configuration/notifications"
          element={
            <ProtectedRoute requiredRoles={['Admin', 'Regulator', 'System User']}>
              <NotificationManagementComponent />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users/regulators"
          element={
            <ProtectedRoute requiredRoles={['Admin', 'Regulator', 'System User']}>
              <UserManagement isEditable={false} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/goods/detail"
          element={
            <ProtectedRoute
              requiredRoles={['Supplier', 'Operator', 'Admin', 'Regulator', 'System User']}
            >
              <ProductDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/services/detail"
          element={
            <ProtectedRoute
              requiredRoles={['Supplier', 'Operator', 'Admin', 'Regulator', 'System User']}
            >
              <ProductDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cart"
          element={
            <ProtectedRoute
              requiredRoles={['Supplier', 'Operator', 'Admin', 'Regulator', 'System User']}
            >
              <CartPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/operator"
          element={
            <ProtectedRoute requiredRoles={['Admin', 'Regulator', 'System User']}>
              <Operator isEditable={false} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/procurement"
          element={
            <ProtectedRoute requiredRoles={['Admin', 'Regulator', 'System User', 'Supplier']}>
              <ProcurementHomepage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/procurement/:serviceInfoId/bids/:tenderBidId"
          element={
            <ProtectedRoute requiredRoles={['Admin', 'Regulator', 'System User', 'Supplier']}>
              <ProcurementBidTimelinePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/procurement/proposals/:id"
          element={
            <ProtectedRoute requiredRoles={['Admin', 'Regulator', 'System User', 'Supplier']}>
              <ProcurementProposalPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/procurement/proposals/:serviceInfoId/bid/:tenderBidId/expressionOfInterest"
          element={
            <ProtectedRoute requiredRoles={['Admin', 'Regulator', 'System User', 'Supplier']}>
              <ExpressionOfInterestProposalPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/procurement/proposals/:serviceInfoId/bid/:tenderBidId/technicalInformation"
          element={
            <ProtectedRoute requiredRoles={['Admin', 'Regulator', 'System User', 'Supplier']}>
              <TechnicalInformationProposalPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/procurement/proposals/:serviceInfoId/bid/:tenderBidId/commercialInformation"
          element={
            <ProtectedRoute requiredRoles={['Admin', 'Regulator', 'System User', 'Supplier']}>
              <CommercialInformationProposalPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/procurement/bid/expressionOfInterest"
          element={
            <ProtectedRoute requiredRoles={['Admin', 'Regulator', 'System User', 'Supplier']}>
              <ExpressionOfInterestPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/procurement/bids/:tenderBidId/technicalInformation"
          element={
            <ProtectedRoute requiredRoles={['Admin', 'Regulator', 'System User', 'Supplier']}>
              <TechnicalInformationPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/procurement/bids/:tenderBidId/commercialInformation"
          element={
            <ProtectedRoute requiredRoles={['Admin', 'Regulator', 'System User', 'Supplier']}>
              <CommercialInformationPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/procurement/bids/:tenderBidId/commercials"
          element={
            <ProtectedRoute requiredRoles={['Admin', 'Regulator', 'System User', 'Supplier']}>
              <CommercialInformationPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/appdesk"
          element={
            <ProtectedRoute requiredRoles={['Operator', 'Admin', 'Regulator', 'System User']}>
              <ApplicationsOnMyDesk />
            </ProtectedRoute>
          }
        />
        <Route
          path="/procurement/create"
          element={
            <ProtectedRoute requiredRoles={['Admin', 'Regulator', 'System User']}>
              <CreateProcurementForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/procurement/edit/:id"
          element={
            <ProtectedRoute requiredRoles={['Admin', 'Regulator', 'System User']}>
              <CreateProcurementForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/requests/procurement-requests"
          element={
            <ProtectedRoute requiredRoles={['Admin', 'Regulator', 'System User', 'Supplier']}>
              <ProcurementRequests />
            </ProtectedRoute>
          }
        />
        {/* <Route path="/supplierProcurements" element={<ProcurementsForSupplier />} /> */}
        <Route
          path="/procurement/supplierRequests/:procurementId"
          element={<SupplierRequestsView onClose={() => {}} />}
        />
        <Route path="/supplierProcurements/bid" element={<ExpressionOfInterestBid />} />
        <Route
          path="/supplierProcurement/procurement-dashboard"
          element={<ProcurementDashboard />}
        />
        <Route path="/notification" element={<NotificationPage />} />

        <Route path="/contracts" element={<ContractsHomePage />} />
        <Route path="/contracts/:contractId" element={<ContractsDetailsPage />} />

        {/* Coming Soon Routes */}
        <Route path="/coming-soon" element={<ComingSoon />} />

        {/* Wildcard Route */}
        <Route path="*" element={<PageNotFound />} />
      </Route>
    </Routes>
  );
};

export default RouterConfig;
